export default {"src":"/_next/static/media/campaign_nofill_2.c055ab92.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};